import { EMPTY_VALUE } from '@betterment/core';
import { formatNumberWithDecimals } from '@betterment/shared-components';

type CashAccount = { __typename: 'CashAccount' };
type DirectTradingAccount = { __typename: 'DirectTradingAccount' };
type ManagedAccount = { __typename: 'ManagedAccount' };

type InvestingAccount = DirectTradingAccount | ManagedAccount;
type Account = CashAccount | DirectTradingAccount | ManagedAccount;

function isCashAccount(account: Account): account is CashAccount {
  return account.__typename === 'CashAccount';
}
function isDirectTradingAccount(account: Account): account is DirectTradingAccount {
  return account.__typename === 'DirectTradingAccount';
}
function isManagedAccount(account: Account): account is ManagedAccount {
  return account.__typename === 'ManagedAccount';
}

export function accountsByType<T extends Account>(accounts: T[]) {
  const cashAccounts: Extract<T, CashAccount>[] = [];
  const investingAccounts: Extract<T, InvestingAccount>[] = [];

  accounts.forEach(account => {
    if (isCashAccount(account)) {
      cashAccounts.push(account as Extract<T, CashAccount>);
    } else if (isDirectTradingAccount(account)) {
      investingAccounts.push(account as Extract<T, InvestingAccount>);
    } else if (isManagedAccount(account)) {
      investingAccounts.push(account as Extract<T, InvestingAccount>);
    }
  });

  return { cashAccounts, investingAccounts };
}

export function formatReturn(value?: number | null): string {
  if (value === null || value === undefined) {
    return EMPTY_VALUE;
  }
  const prefix = value > 0 ? '+' : '';
  return `${prefix}${formatNumberWithDecimals(value, 2)}%`;
}

export function formatReturnColor(value?: number | null): string {
  if (value === null || value === undefined) {
    return 'text.weak';
  }
  return value > 0 ? 'text.success' : 'text';
}
